import { render, staticRenderFns } from "./CalcQueue.vue?vue&type=template&id=79136e35&scoped=true"
import script from "./CalcQueue.vue?vue&type=script&lang=ts"
export * from "./CalcQueue.vue?vue&type=script&lang=ts"
import style0 from "./CalcQueue.vue?vue&type=style&index=0&id=79136e35&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "79136e35",
  null
  
)

export default component.exports